const enabled = false;

export const logGroup = (groupName, callback) => {
  if (!enabled) {
    callback();
    return;
  }
  console.group(groupName);
  try {
    callback();
  } finally {
    console.groupEnd();
  }
};
